import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import FNOLCPWizard from './FNOLCPWizard';
import FNOLCPBuildingPage from './pages/CPBuilding/BuildingPage';
import FNOLCPDetailsPage from './pages/Details/DetailsPage';
import FNOLCPWhatPage from './pages/What/WhatPage';

setComponentMapOverrides(
    {
        FNOLCPWizard: { component: 'FNOLCPWizard' },
        FNOLCPWhatPage: { component: 'FNOLCPWhatPage' },
        FNOLCPDetailsPage: { component: 'FNOLCPDetailsPage' },
        FNOLCPBuildingPage: { component: 'FNOLCPBuildingPage' },
    },
    {
        FNOLCPWizard,
        FNOLCPWhatPage,
        FNOLCPDetailsPage,
        FNOLCPBuildingPage,
    }
);

export { FNOLCPWizard as default };
